import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  electronicForms: "ElectronicForm.ElectronicForms",
  list: "ElectronicForm.ElectronicFormList",
};

export { names as electronicFormRouteNames };

const electronicFormRoutes: RouterOptions["routes"] = [
  {
    path: "/electronicForm",
    name: names.electronicForms,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Electronic Forms" },
        component: () => import("@/views/electronicForm/ElectronicFormList.vue"),
      },
    ],
  },
];
export default electronicFormRoutes;
